import  { createContext } from 'react';
import { StatusBoardState, StatusBoardAction } from '../types';

interface ContextProps {
  state: StatusBoardState;
  dispatch: (action: StatusBoardAction) => void;
}

export const StatusBoardContext = createContext({} as ContextProps);
